module.exports = __webpack_public_path__ + "img/about.bedb4ef9.jpg";